/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useSelector, getLocale, useDispatch, shallowEqual } from 'umi';
import Menu from '@/pages/dashboard/components/LeftMenu/components/Menu';
import { PAGE_TYPE_OUT_PATH } from '../../_config/constant';

const ICON_MAP: any = {
  overview: 'application',
  realtime: 'clock',
  engagement: 'engagement',
  revenue: 'money',
  monetization: 'money',
  comparisonanalysis: 'vs-icon',
  multitimezone: 'multi-timezone',
  ua: 'user-ua',
  competitor: 'competitor',
  favorites: 'collect',
  folder: 'folder-m',
  benchmark: 'benchmark',
  activity: 'flag-m',
  default: 'default-chart', // 报表默认图标
  funnel: 'funnel-icon',
  eventanalysis: 'event-analysis-icon',
  performance: 'performance-icon',
  wishlist: 'wishlist-icon',
  refundanalysis: 'refund-analysis-icon',
  'sales&monetization': 'money',
  'salesmonetization': 'money',
};
// benchmark:'benchmark',
// activity:'flag-m'
// 默认报表:'default-chart'

const menuIdMap = {
  '/overview/daily': 'menu-overview-daily',
  '/realtime/users': 'menu-realtime-user',
  '/comparisonAnalysis/countryComparison': 'menu-country-comparison',
  '/multiTimezone/dailyTimezone/country': 'menu-daily-time-country',
  '/subscribe/subscribeSetting': 'menu-overview-daily',
  '/preset/report/Active-User-Profile': 'menu-tableau-daily-report',
} as any;

export default function NavigaMenu(props: any) {
  const { isNormal, onSet, setModalInfoState, setActiveIndex, isAccess = true } = props;
  const local = getLocale();
  const dispatch = useDispatch();
  // const [opened, setOpened] = useState<any>({});
  // const [formatMenuList, setFormatMenuList] = useState([]);
  // const [activeInfo, setActiveInfo] = useState<any>({});
  // let [visible,setVisible] = useState(false)
  const { menuList, currentMenu, currentGame, showNewMenusMap } = useSelector(state => {
    // @ts-ignore
    const { menuList, currentMenu, currentGame, showNewMenusMap } = state.dashboard;

    return {
      currentGame,
      menuList,
      currentMenu,
      showNewMenusMap,
    };
  }, shallowEqual);

  // const formatMenuList = useMemo(() => {
  //   const nameKey = local === 'zh-CN' ? 'name_cn' : 'name_en';
  //   return (menuList || []).map((menu: any) => {
  //     return {
  //       ...menu,
  //       text: menu?.[nameKey] || menu?.name_en || '',
  //       folder_list: (menu?.folder_list || []).map((folder: any) => {
  //         // 特性报表使用 文件夹图标, 根据后端接口字段business_type判断
  //         // default 是报表的默认图标.
  //         const iconKey = menu.business_type === 'feature' ? 'folder' : folder?.name_en || 'default';
  //         return {
  //           ...folder,
  //           text: folder?.[nameKey] || folder?.name_en || '',
  //           icon: ICON_MAP?.[iconKey.replaceAll(' ', '')?.toLowerCase()] || ICON_MAP['default'],
  //           dashoboard_list: (folder?.dashoboard_list || []).map((dashoboard: any) => {
  //             return {
  //               ...dashoboard,
  //               text: dashoboard?.[nameKey] || dashoboard?.name_en || '',
  //             }
  //           }),
  //           defaultOpened:[758, 762].includes(folder?.id) || ["Overview", "Real time"].includes(folder?.name_en)
  //         }
  //       })
  //     }
  //   })
  // }, [menuList, local]);

  const formatMenuList = useMemo(() => {
    const defaultOpened: any = {};
    const nameKey = local === 'zh-CN' ? 'name_cn' : 'name_en';
    const idMap: any = {};

    const newFormatMenuList = (menuList || []).map((menu: any) => ({
      ...menu,
      text: menu?.[nameKey] || menu?.name_en || '',
      folder_list: (menu?.folder_list || []).map((folder: any) => {
        defaultOpened[folder?.name_en] = folder.isDefaultOpen;
        // 特性报表使用 文件夹图标, 根据后端接口字段business_type判断
        // default 是报表的默认图标.
        const iconKey = menu.business_type === 'feature' ? 'folder' : folder?.name_en || 'default';
        return {
          ...folder,
          text: folder?.[nameKey] || folder?.name_en || '',
          icon: ICON_MAP?.[iconKey.replaceAll(' ', '')?.toLowerCase()] || ICON_MAP.default,
          dashoboard_list: (folder?.dashoboard_list || []).map((dashoboard: any) => {
            let eleId = undefined;
            const { page_type: type, path } = dashoboard;
            if ((type === 'path' || !type) && path && !idMap[path]) {
              idMap[path] = 1;
              eleId = menuIdMap[path];
            }
            // 三级目录
            let subDashoboardList = dashoboard?.dashoboard_list || [];
            if (dashoboard?.menu_type === '3') {
              subDashoboardList = (dashoboard?.dashoboard_list || []).map((subDashoboard: any) => {
                let eleId = undefined;
                const { page_type: type, path } = subDashoboard;
                if ((type === 'path' || !type) && path && !idMap[path]) {
                  idMap[path] = 1;
                  eleId = menuIdMap[path];
                }
                return {
                  eleId,
                  ...subDashoboard,
                  text: subDashoboard?.[nameKey] || subDashoboard?.name_en || '',
                };
              });
            }
            // 'Daily report' 添加新手引导,id和名称都是不固定的，所以这里用workbook_url来做判断
            // if(dashoboard?.workbook_url ===  "Dailyemailreport_16276161792650/sheets/Daily") {
            // if (dashoboard?.name_en === "54e81161-a7ab-420a-adc4-31745a2473d3") {
            if (dashoboard?.name_en === "Active User Profile") {
              eleId = 'menu-tableau-daily-report';
            }
            return {
              eleId,
              ...dashoboard,
              text: dashoboard?.[nameKey] || dashoboard?.name_en || '',
              dashoboard_list: subDashoboardList || dashoboard?.dashoboard_list || [],
            };
          }),
          // defaultOpened: defaultOpened[folder?.name_en],
        };
      })
    }));
    // setFormatMenuList(newFormatMenuList);
    // setOpened({ ...defaultOpened, ...opened })
    return newFormatMenuList;
  }, [menuList, local]);

  // 菜单变化，定位左侧菜单位置
  useEffect(() => {
    if (!currentMenu || currentMenu?.page_type === PAGE_TYPE_OUT_PATH) {
      return;
    }
    const $dashboardList = document.getElementsByClassName(`js-menu-dashboard-${currentMenu.id}`);
    if ($dashboardList.length < 1) {
      return;
    }

    // 检查当前菜单是否在视野范围内
    const inWindow = [...$dashboardList].some((item: any) => {
      const rectObject = item.getBoundingClientRect();
      const bottomHeight = 42; // 菜单区域下边界与底部的距离
      const topHeight = 242;  // 菜单区域上边界与顶部的距离
      // const selfHalfHeight = 36/2;  //一个菜单项的半高
      const selfHalfHeight = 0;  // 一个菜单项的半高
      const parentElement = item?.parentElement?.parentElement;
      if (parentElement?.classList.contains('is-expanded') && rectObject?.top <= window.innerHeight - bottomHeight - selfHalfHeight && rectObject?.bottom >= topHeight + selfHalfHeight) {
        // item?.parentElement?.parentElement?.parentElement && item?.parentElement?.parentElement?.parentElement?.classList.add('is-expanded')
        // item?.scrollIntoView({behavior: "smooth", block: "center"});
        return true;
      }
      return false;
    });
    // 不在视野的情况下，滚动到视野中
    if (!inWindow) {
      let $parentElement = $dashboardList[0]?.parentElement?.parentElement;

      // 解决因菜单外层加了A标签，导致这里获取父类节点有问题
      if($parentElement?.nodeName === 'UL'){
        $parentElement = $parentElement.parentElement;
      }

      if ($parentElement && !$parentElement.classList.contains('is-expanded')) {
        // @ts-ignore
        $parentElement?.childNodes?.[0].click(); // 模拟点击

        if(!$parentElement.classList.contains('left-nav-menu')){
          const $mainParentElement = $parentElement?.parentElement?.parentElement;
          if($mainParentElement && !$mainParentElement?.classList.contains('is-expanded') && $mainParentElement?.classList.contains('left-nav-menu')){
            $mainParentElement?.childNodes?.[0].click();
          }
        }
      }
      // 强制异步执行
      setTimeout(() => {
        $dashboardList[0]?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 10);
    }

    // 判断是否要取消目录上的New 标记
    const showNew = showNewMenusMap.get(currentMenu.parent_name_en)?.has(currentMenu.name_en);
    // 如果当前展示了 New, 首次点击的时候需要上报. 同时前端也要更新菜单状态
    // 搜索页面时, 点击跳转也需要执行此操作
    if (showNew) {
      dispatch({
        type: "dashboard/cancelMenuNewStatusLog",
        payload: {
          gameCode: currentGame.game_code,
          path: currentMenu.path,
          nameEn: currentMenu.name_en,
          folderNameEn: currentMenu.parent_name_en
        }
      });
    }
  }, [currentMenu]);

  // 报表名称过长显示省略号生成浮窗
  // const renderContent = (item: { text: string, id: string }) => {
  //   const { text = '', id = '' } = item || {}
  //   const menuTitle = document.getElementsByClassName(`db-menu-title-${id}`)
  //   return menuTitle?.[0]?.scrollHeight > menuTitle?.[0]?.clientHeight ? text : null
  // }

  // 菜单点击操作行
  // const renderActive = (item: { id: string }) => {
  //   const { id = '' } = item || {}
  //   return activeInfo?.show && activeInfo?.id === id ? 'active' : ''
  // }

  // 菜单收起包含选中报表
  // const renderSelect = (item: { name_en: string, id: string }) => {
  //   const { name_en = '', id = '' } = item || {}
  //   return !opened[name_en] && currentMenu?.folder_id === id ? 'is-selected' : ''
  // }

  return (
    <div className='navmenu-bd' id="dtb-db-leftmenu" onClick={() => { setActiveIndex('') }}>
      {!isAccess ? null : isNormal ? <Menu menuList={formatMenuList} setModalInfoState={setModalInfoState} showNewMenusMap={showNewMenusMap} /> :
        (formatMenuList || []).map((menu: any) => {
          const iconList: any = [];
          return (menu?.folder_list || []).length > 0 ? <div className='width-item' key={menu.id}>
            <div className='width-item-line' />
            {(menu?.folder_list || []).map((folder: any) => {
              // 左侧菜单收起时，特性报表相同的icon只展示一个即可
              if (menu?.name_en === 'Customized' && menu?.business_type === 'feature') {
                const icon = iconList?.includes(folder?.icon) ? 'repeat' : folder?.icon;
                iconList.push(icon);
                let selectedIcon = '';
                const isSelectedList = menu?.folder_list?.map((v: any) => {
                  if (v?.id === currentMenu?.parent_id) selectedIcon = v?.icon;
                  return v?.id === currentMenu?.parent_id;
                });
                const isSelected = isSelectedList?.includes(true) && selectedIcon === folder?.icon;
                return icon !== 'repeat' && <div
                  key={folder.id}
                  className={`width-item-icon ${isSelected ? 'width-item-action' : ""}`}
                  onClick={() => { if (!isNormal) onSet(false); }}>
                  <SvgIcon className='width-icon' type={folder?.icon} />
                </div>;
              }
              return <div
                key={folder.id}
                className={`width-item-icon ${currentMenu?.parent_id === folder?.id ? 'width-item-action' : ""}`}
                onClick={() => { if (!isNormal) onSet(false); }}>
                <SvgIcon className='width-icon' type={folder?.icon} />
              </div>;
            })}
          </div> : '';
        })
      }
    </div>
  );
};
